document.addEventListener('alpine:init', () => {
  function tabs(data = {}) {
    return {
      ...data,

      select(id) {
        this.selectedId = id
      },

      getSelectedState(id) {
        return this.selectedId === id
      },
    };
  };

  Alpine.data('tabs', tabs);
});
